import { forwardRef } from 'react';
import { Link as RrdLink, LinkProps } from 'react-router-dom';

import { IconButton, IconButtonProps } from '@components/base';

export type RouterIconButtonProps = Omit<LinkProps, 'instance'> &
  Omit<IconButtonProps, 'component' | 'href'>;

export const RouterIconButton = forwardRef<HTMLButtonElement, RouterIconButtonProps>(
  (props, ref) => <IconButton {...props} component={RrdLink} onClick={props.onClick} ref={ref} />
);

RouterIconButton.displayName = 'RouterIconButton';
